export default __webpack_public_path__ + "static/media/46-min.8aa4fca5.png";